import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import api from '../../api/axios';
import { ItemDTO } from '../../components/user/sell/types/Inventory';

export interface CartItemDTO {
  offerId: string;
  priceMinor: number;
  item: ItemDTO;
  selectedBuyerSteamAccountId: string;
}

interface CartState {
  items: CartItemDTO[];
  loading: boolean;
}

const initialState: CartState = {
  items: [],
  loading: false,
};

export const fetchCart = createAsyncThunk('cart/fetchCart', async () => {
  const response = await api.get<CartItemDTO[]>('/cart');
  return response.data;
});

export const removeItemFromCart = createAsyncThunk(
    'cart/removeItem',
    async (offerId: string) => {
      await api.delete(`/cart/${offerId}`);
      return offerId;
    }
);

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCartLocally: (state, action: PayloadAction<CartItemDTO>) => {
      const exists = state.items.find((i: CartItemDTO) => i.offerId === action.payload.offerId);
      if (!exists) {
        state.items.push(action.payload);
      }
    },
    // Removes the item only from the Redux state
    removeItemFromCartLocally: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item: CartItemDTO) => item.offerId !== action.payload);
    },
    updateItemBuyerAccount: (state, action: PayloadAction<{ offerId: string; accountId: string }>) => {
      const item = state.items.find((i: CartItemDTO) => i.offerId === action.payload.offerId);
      if (item) {
        item.selectedBuyerSteamAccountId = action.payload.accountId;
      }
    },
    clearCartLocally: (state) => {
      state.items = [];
    }
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchCart.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchCart.fulfilled, (state, action: PayloadAction<CartItemDTO[]>) => {
      state.items = action.payload;
      state.loading = false;
    })
    .addCase(fetchCart.rejected, (state) => {
      state.loading = false;
    })
    .addCase(removeItemFromCart.fulfilled, (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.offerId !== action.payload);
    });
  },
});

export const { addToCartLocally, removeItemFromCartLocally, updateItemBuyerAccount, clearCartLocally } = cartSlice.actions;
export default cartSlice.reducer;